// extracted by mini-css-extract-plugin
export default {"link":"nD-z","disabled":"oD-z"};